import Vue from 'vue';
import * as VSensors from '@3vjia/v-sensors';
import javascriptBridge from '@/core/lib/javascript-bridge';

const productName = javascriptBridge.device.swjApp ? 'designer_app' : 'designer_app_H5';
VSensors.sensors.registerPage({
  product_name: productName,
});

Vue.use(VSensors, {
  env: process.env.VUE_APP_ENV,
  isAutoTrack: false,
}, {
  app_js_bridge: true,
});

Vue.prototype.$sensors = VSensors.sensors;
